import { render, staticRenderFns } from "./correlationInform.vue?vue&type=template&id=b3f3e6e0&scoped=true"
import script from "./correlationInform.vue?vue&type=script&lang=js"
export * from "./correlationInform.vue?vue&type=script&lang=js"
import style0 from "./correlationInform.vue?vue&type=style&index=0&id=b3f3e6e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f3e6e0",
  null
  
)

export default component.exports